<!--components/app/BlockUI-->
<template>
	<v-overlay :value="show" opacity=".6" :z-index="99999">
		<v-card
			elevation="20"
			:light="!darkMode"
			max-width="400"
		>

			<v-card-text>
				<div class="text-center">
					<v-icon
						size="60"
						class="rotating-blockui mb-4"
						color="primary"
					>
						fas fa-spinner
					</v-icon>
				</div>

				<div :class="getBlockUiTextClass">{{ text }}</div>
			</v-card-text>
		</v-card>
	</v-overlay>
</template>

<script>
	export default {
		props: {
			darkMode: {
				type: Boolean,
				default: false
			},

			show: {
				type: Boolean,
				default: false
			},

			text: {
				type: String,
				default: undefined
			}
		},

		computed: {
			getBlockUiTextClass() {
				return this.darkMode ? '' : 'black--text';
			}
		}
	}
</script>

<style>
	@keyframes rotating-blockui {
		from {
			transform: rotate(0deg);
			-o-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
			-o-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-webkit-transform: rotate(360deg);
		}
	}

	@-webkit-keyframes rotating-blockui {
		from {
			transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
			-webkit-transform: rotate(360deg);
		}
	}

	.rotating-blockui {
		-webkit-animation: rotating-blockui 2s linear infinite;
		-moz-animation: rotating-blockui 2s linear infinite;
		-ms-animation: rotating-blockui 2s linear infinite;
		-o-animation: rotating-blockui 2s linear infinite;
		animation: rotating-blockui 2s linear infinite;
	}
</style>